import VersionView from "./VersionView";

function Version({ style, fixed = false }) {
  return <VersionView style={style} fixed={fixed} />;
}

export default Version;
